var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroupWhiteTransparent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.001,
    height: 32,
    viewBox: "0 0 38.001 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group",
    transform: "translate(-5 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_27",
    "data-name": "Union 27",
    d: "M-12355-8762v-2a7.834,7.834,0,0,1,7-4,7.832,7.832,0,0,1,7,4v2Zm-24,0v-2a7.832,7.832,0,0,1,7-4,7.836,7.836,0,0,1,7,4v2Zm12-8v-2a7.831,7.831,0,0,1,7-4,7.832,7.832,0,0,1,7,4v2Zm12-9v-2a7.834,7.834,0,0,1,7-4,7.831,7.831,0,0,1,7,4v2Zm-24,0v-2a7.831,7.831,0,0,1,7-4,7.836,7.836,0,0,1,7,4v2Z",
    transform: "translate(12384 8801.999)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M16,12a4,4,0,1,1-4-4,4,4,0,0,1,4,4m24,0a4,4,0,1,1-4-4,4,4,0,0,1,4,4",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M16,29a4,4,0,1,1-4-4,4,4,0,0,1,4,4m24,0a4,4,0,1,1-4-4,4,4,0,0,1,4,4M28,21a4,4,0,1,1-4-4,4,4,0,0,1,4,4",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupWhiteTransparent);
export default __webpack_public_path__ + "static/media/user-group_white-transparent.4c8809b9e401c0105c662415dc6afbfa.svg";
export { ForwardRef as ReactComponent };